import { render, staticRenderFns } from "./yxjsh.vue?vue&type=template&id=9a23dcd8&scoped=true&"
import script from "./yxjsh.vue?vue&type=script&lang=js&"
export * from "./yxjsh.vue?vue&type=script&lang=js&"
import style0 from "./yxjsh.vue?vue&type=style&index=0&id=9a23dcd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a23dcd8",
  null
  
)

export default component.exports